export default __webpack_public_path__ + "static/gst_return_filling-4f825148a3b08ef7ae5098d1c0ba070a.png";